import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import BusinessRulesSpecificInfo from "../components/BusinessRulesSpecificInfo";
import ModuleSpecificInfo from "../components/ModuleSpecificInfo";
import { Container, Row, Col } from "react-bootstrap";

export default function BusinessModal({
  modalStatus,
  handleBuinessOpenModal,
  moduleDetails,
  bModules,
}) {
  const handleClose = () => {
    handleBuinessOpenModal(false);
  };

  const renderModuleSpecificInfo = () => {
    if (!moduleDetails || Object.keys(moduleDetails).length <= 0) {
      return <div></div>;
    }
    const jsx = (
      <div>
        {moduleDetails && Object.keys(moduleDetails).length > 0 && (
          <div className="module-specific-info">
            <ModuleSpecificInfo module={moduleDetails} />
            {moduleDetails && moduleDetails.moduleBusinessRules && (
              <BusinessRulesSpecificInfo
                module={moduleDetails}
                bModules={bModules}
              />
            )}
          </div>
        )}
      </div>
    );
    return jsx;
  };

  return (
    <>
      <Dialog
        open={modalStatus}
        onClose={handleClose}
        className="buisness-modal"
        overlayStyle={{ backgroundColor: "transparent" }}>
        <DialogTitle>
          <div className="buisness-ModalHeading">
            Module-specific information
          </div>
          <IconButton onClick={handleClose} size="large">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent className="custonScrollBar">
          <Container>
            <Row>
              <Col>
                <div className="bodyContentBg  ">
                  {renderModuleSpecificInfo()}
                </div>
              </Col>
            </Row>
          </Container>
        </DialogContent>
      </Dialog>
    </>
  );
}
